export const formatDate = (date) => {
  if (!date) return '—';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) return date;
  const d = new Date(date);
  if (isNaN(d.getTime())) return date;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return day + '/' + month + '/' + year;
};

export const formatDateISO = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return y + '-' + m + '-' + day;
};

export const getCurrentSunday = () => {
  const now = new Date();
  const day = now.getDay();
  const diff = now.getDate() - day;
  const sunday = new Date(now.getFullYear(), now.getMonth(), diff);
  sunday.setHours(0, 0, 0, 0);
  return formatDateISO(sunday);
};

export const tinhTrungBinh = (mieng = [], m15phut = [], m1tiet = [], hk = 0) => {
  const tbMieng = mieng.length ? mieng.reduce((a, b) => a + b, 0) / mieng.length : 0;
  const tb15 = m15phut.length ? m15phut.reduce((a, b) => a + b, 0) / m15phut.length : 0;
  const tb1t = m1tiet.length ? m1tiet.reduce((a, b) => a + b, 0) / m1tiet.length : 0;
  return ((tbMieng + tb15 + tb1t * 2 + hk * 3) / 7).toFixed(1);
};

export const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const validatePhone = (phone) => /^0\d{9}$/.test(phone);
export const required = (value) => !!value && value.toString().trim().length > 0;
export * from './validation';